var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubnavDash(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.503v3.979a2.462 2.462 0 01-.728 1.764 2.533 2.533 0 01-1.764.728H2.492A2.482 2.482 0 010 6.482v-3.98A2.503 2.503 0 012.492 0h15.016a2.502 2.502 0 011.764.738A2.463 2.463 0 0120 2.503zM8.974 13.518v3.99A2.482 2.482 0 016.482 20h-3.99A2.483 2.483 0 010 17.508v-3.98a2.503 2.503 0 012.492-2.502h3.99a2.483 2.483 0 011.754.738c.466.466.73 1.095.738 1.754zm11.026.01v3.98a2.462 2.462 0 01-.728 1.764 2.533 2.533 0 01-1.764.728h-3.99a2.513 2.513 0 01-1.764-.728 2.461 2.461 0 01-.728-1.764v-3.98a2.523 2.523 0 012.492-2.502h3.99a2.502 2.502 0 011.764.738A2.463 2.463 0 0120 13.528z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubnavDash);
export default ForwardRef;